export default __webpack_public_path__ + "static/media/angos.e8ba0d54.png";